/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recovery_Rest_BodyInputs */

const en_us2_recovery_rest_body = /** @type {(inputs: Recovery_Rest_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No workout on the plan today. Muscle rebuilds while you rest, so enjoy it.`)
};

const pt_br2_recovery_rest_body = /** @type {(inputs: Recovery_Rest_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoje não tem treino no plano. É no descanso que o músculo se reconstrói, então aproveite.`)
};

const es_419_recovery_rest_body = /** @type {(inputs: Recovery_Rest_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoy no hay entrenamiento en el plan. El músculo se reconstruye mientras descansas, así que aprovecha.`)
};

const pt_pt2_recovery_rest_body = /** @type {(inputs: Recovery_Rest_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoje não há treino no plano. É no descanso que o músculo se reconstrói, por isso aproveita.`)
};

const fr_fr2_recovery_rest_body = /** @type {(inputs: Recovery_Rest_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas de séance prévue aujourd'hui. Le muscle se reconstruit pendant le repos, alors profites-en.`)
};

const de_de2_recovery_rest_body = /** @type {(inputs: Recovery_Rest_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heute steht kein Training im Plan. Muskeln bauen sich in der Pause wieder auf, also genieß sie.`)
};

const it_it2_recovery_rest_body = /** @type {(inputs: Recovery_Rest_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oggi la scheda non prevede allenamento. Il muscolo si ricostruisce mentre riposi, quindi goditelo.`)
};

/**
* | output |
* | --- |
* | "No workout on the plan today. Muscle rebuilds while you rest, so enjoy it." |
*
* @param {Recovery_Rest_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const recovery_rest_body = /** @type {((inputs?: Recovery_Rest_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recovery_Rest_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_recovery_rest_body(inputs)
	if (locale === "es-419") return es_419_recovery_rest_body(inputs)
	if (locale === "pt-PT") return pt_pt2_recovery_rest_body(inputs)
	if (locale === "fr-FR") return fr_fr2_recovery_rest_body(inputs)
	if (locale === "de-DE") return de_de2_recovery_rest_body(inputs)
	if (locale === "it-IT") return it_it2_recovery_rest_body(inputs)
	return en_us2_recovery_rest_body(inputs)
});
export { recovery_rest_body as "recovery.rest_body" }